module.exports = __webpack_public_path__ + "web/img/speech1.f79bd8cd.png";